const SlardarDomainVRegionMap = {
  sg: "mon.tiktokv.com",
  va: "mon.tiktokv.com",
  gcp: "mon-i18n.tiktokv.com",
  "eu-ttp": "mon-i18n.tiktokv.com",
  "eu-ttp2": "mon-i18n.tiktokv.com",
  "us-ttp": "mon16-normal-useast5.tiktokv.us",
  "us-ttp2": "mon16-normal-useast5.tiktokv.us"
};
const SlardarDomainVGeoMap = {
  row: SlardarDomainVRegionMap.sg,
  eu: SlardarDomainVRegionMap["eu-ttp"],
  us: SlardarDomainVRegionMap["us-ttp"]
};
const SlardarSdkUrlVRegionMap = {
  sg: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/slardar/fe/sdk-web/browser.sg.js",
  va: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/slardar/fe/sdk-web/browser.sg.js",
  gcp: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/slardar/fe/sdk-web/browser.sg.js",
  "eu-ttp": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/slardar/fe/sdk-web/browser.sg.js",
  "eu-ttp2": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/slardar/fe/sdk-web/browser.sg.js",
  "us-ttp": "https://lf16-cdn-tos.tiktokcdn-us.com/obj/static-tx/slardar/fe/sdk-web/browser.oci.js",
  "us-ttp2": "https://lf16-cdn-tos.tiktokcdn-us.com/obj/static-tx/slardar/fe/sdk-web/browser.oci.js"
};
const SlardarSdkUrlVGeoMap = {
  row: SlardarSdkUrlVRegionMap.sg,
  eu: SlardarSdkUrlVRegionMap["eu-ttp"],
  us: SlardarSdkUrlVRegionMap["us-ttp"]
};
const SlardarPluginPathPrefixVRegionMap = {
  sg: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/slardar/fe/sdk-web/plugins",
  va: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/slardar/fe/sdk-web/plugins",
  gcp: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/slardar/fe/sdk-web/plugins",
  "eu-ttp": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/slardar/fe/sdk-web/plugins",
  "eu-ttp2": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/slardar/fe/sdk-web/plugins",
  "us-ttp": "https://lf16-cdn-tos.tiktokcdn-us.com/obj/static-tx/slardar/fe/sdk-web/plugins",
  "us-ttp2": "https://lf16-cdn-tos.tiktokcdn-us.com/obj/static-tx/slardar/fe/sdk-web/plugins"
};
const SlardarPluginPathPrefixVGeoMap = {
  row: SlardarPluginPathPrefixVRegionMap.sg,
  eu: SlardarPluginPathPrefixVRegionMap["eu-ttp"],
  us: SlardarPluginPathPrefixVRegionMap["us-ttp"]
};
const SlardarCspPreScriptUrlVRegionMap = {
  sg: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok-infra/csp/sdk-pre/slardar.web.pre.js",
  va: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok-infra/csp/sdk-pre/slardar.web.pre.js",
  gcp: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok-infra/csp/sdk-pre/slardar.web.pre.js",
  "eu-ttp": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok-infra/csp/sdk-pre/slardar.web.pre.js",
  "eu-ttp2": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok-infra/csp/sdk-pre/slardar.web.pre.js",
  "us-ttp": "https://lf16-cdn-tos.tiktokcdn-us.com/obj/static-tx/tiktok-infra/csp/sdk-pre/slardar.web.pre.js",
  "us-ttp2": "https://lf16-cdn-tos.tiktokcdn-us.com/obj/static-tx/tiktok-infra/csp/sdk-pre/slardar.web.pre.js"
};
const SlardarCspPreScriptUrlVGeoMap = {
  row: SlardarCspPreScriptUrlVRegionMap.sg,
  eu: SlardarCspPreScriptUrlVRegionMap["eu-ttp"],
  us: SlardarCspPreScriptUrlVRegionMap["us-ttp"]
};
const SlardarGeckoSdkUrlVRegionMap = {
  sg: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/slardar/sdk-web-sg.js",
  va: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/slardar/sdk-web-va.js",
  gcp: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/slardar/sdk-web-euttp.js",
  "eu-ttp": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/slardar/sdk-web-euttp.js",
  "eu-ttp2": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/slardar/sdk-web-euttp.js",
  "us-ttp": "https://lf16-tiktok-common.tiktokcdn-us.com/obj/tiktok-web-common-tx/tiktok/fe/common/gando_libs/slardar/sdk-web-ttp.js",
  "us-ttp2": "https://lf16-tiktok-common.tiktokcdn-us.com/obj/tiktok-web-common-tx/tiktok/fe/common/gando_libs/slardar/sdk-web-ttp.js"
};
const SlardarGeckoSdkUrlVGeoMap = {
  row: SlardarGeckoSdkUrlVRegionMap.sg,
  eu: SlardarGeckoSdkUrlVRegionMap["eu-ttp"],
  us: SlardarGeckoSdkUrlVRegionMap["us-ttp"]
};
const SlardarGeckoPluginPathPrefixVRegionMap = {
  sg: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/slardar/plugins",
  va: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/slardar/plugins",
  gcp: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/slardar/plugins",
  "eu-ttp": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/slardar/plugins",
  "eu-ttp2": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/slardar/plugins",
  "us-ttp": "https://lf16-tiktok-common.tiktokcdn-us.com/obj/tiktok-web-common-tx/tiktok/fe/common/gando_libs/slardar/plugins",
  "us-ttp2": "https://lf16-tiktok-common.tiktokcdn-us.com/obj/tiktok-web-common-tx/tiktok/fe/common/gando_libs/slardar/plugins"
};
const SlardarGeckoPluginPathPrefixVGeoMap = {
  row: SlardarGeckoPluginPathPrefixVRegionMap.sg,
  eu: SlardarGeckoPluginPathPrefixVRegionMap["eu-ttp"],
  us: SlardarGeckoPluginPathPrefixVRegionMap["us-ttp"]
};
const SlardarGeckoCspPreScriptUrlVRegionMap = {
  sg: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/slardar/sdk-web-pre-sg.js",
  va: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/slardar/sdk-web-pre-sg.js",
  gcp: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/slardar/sdk-web-pre-sg.js",
  "eu-ttp": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/slardar/sdk-web-pre-sg.js",
  "eu-ttp2": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/slardar/sdk-web-pre-sg.js",
  "us-ttp": "https://lf16-tiktok-common.tiktokcdn-us.com/obj/tiktok-web-common-tx/tiktok/fe/common/gando_libs/slardar/sdk-web-pre-ttp.js",
  "us-ttp2": "https://lf16-tiktok-common.tiktokcdn-us.com/obj/tiktok-web-common-tx/tiktok/fe/common/gando_libs/slardar/sdk-web-pre-ttp.js"
};
const SlardarGeckoCspPreScriptUrlVGeoMap = {
  row: SlardarGeckoCspPreScriptUrlVRegionMap.sg,
  eu: SlardarGeckoCspPreScriptUrlVRegionMap["eu-ttp"],
  us: SlardarGeckoCspPreScriptUrlVRegionMap["us-ttp"]
};
const SlardarResources = {
  domainVRegionMap: SlardarDomainVRegionMap,
  domainVGeoMap: SlardarDomainVGeoMap,
  sdkUrlVRegionMap: SlardarSdkUrlVRegionMap,
  sdkUrlVGeoMap: SlardarSdkUrlVGeoMap,
  pluginPathPrefixVRegionMap: SlardarPluginPathPrefixVRegionMap,
  pluginPathPrefixVGeoMap: SlardarPluginPathPrefixVGeoMap,
  cspPreScriptUrlVRegionMap: SlardarCspPreScriptUrlVRegionMap,
  cspPreScriptUrlVGeoMap: SlardarCspPreScriptUrlVGeoMap,
  geckoSdkUrlVRegionMap: SlardarGeckoSdkUrlVRegionMap,
  geckoSdkUrlVGeoMap: SlardarGeckoSdkUrlVGeoMap,
  geckoPluginPathPrefixVRegionMap: SlardarGeckoPluginPathPrefixVRegionMap,
  geckoPluginPathPrefixVGeoMap: SlardarGeckoPluginPathPrefixVGeoMap,
  geckoCspPreScriptUrlVRegionMap: SlardarGeckoCspPreScriptUrlVRegionMap,
  geckoCspPreScriptUrlVGeoMap: SlardarGeckoCspPreScriptUrlVGeoMap
};
export {
  SlardarCspPreScriptUrlVGeoMap,
  SlardarCspPreScriptUrlVRegionMap,
  SlardarDomainVGeoMap,
  SlardarDomainVRegionMap,
  SlardarGeckoCspPreScriptUrlVGeoMap,
  SlardarGeckoCspPreScriptUrlVRegionMap,
  SlardarGeckoPluginPathPrefixVGeoMap,
  SlardarGeckoPluginPathPrefixVRegionMap,
  SlardarGeckoSdkUrlVGeoMap,
  SlardarGeckoSdkUrlVRegionMap,
  SlardarPluginPathPrefixVGeoMap,
  SlardarPluginPathPrefixVRegionMap,
  SlardarResources,
  SlardarSdkUrlVGeoMap,
  SlardarSdkUrlVRegionMap
};

//# sourceMappingURL=slardar.js.map